/** This file was generated by src/infrastructure/scripts/executables/backend-schema-types.ts */
export type paths = {
    readonly '/api/v2/resource-runners': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    /** @description Number of items per page */
                    readonly itemsPerPage?: number
                    /** @description Limit to specific `runner`s */
                    readonly names?: readonly string[]
                    /** @description Page to return */
                    readonly page?: number
                }
                readonly header: {
                    readonly Authorization: string
                }
                readonly path?: never
                readonly cookie?: never
            }
            readonly requestBody?: never
            readonly responses: {
                /** @description List of heartbeats */
                readonly 200: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': {
                            readonly data: readonly {
                                /**
                                 * Resource runner health
                                 * @description Represents if resource runners are or not healthy
                                 */
                                readonly healthy: boolean
                                readonly hostname: string
                                readonly last: number
                                /**
                                 * Resource runner missed heartbeats
                                 * @description Represents the count of missed heartbeats
                                 */
                                readonly misses: number
                                /**
                                 * Name
                                 * @description Resource Runner Name
                                 */
                                readonly name: string
                                /**
                                 * Resource runner remaining missed heartbeats
                                 * @description Represents the number of allowed heartbeats misses for the resource runner
                                 *     until it becomes unhealthy
                                 */
                                readonly remainingMissedHeartbeats: number
                                readonly version: string
                            }[]
                            readonly meta: {
                                readonly pagination: {
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly nextPage: number
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly pageNumber: number
                                    /**
                                     * @description Number of items per page
                                     * @default 50
                                     */
                                    readonly rowsPerPage: number
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly totalPages: number
                                    readonly totalRows: number
                                    readonly totalRowsInPage: number
                                }
                            }
                        }
                    }
                }
                /** @description Service Unavailable (Infrastructure error) */
                readonly 503: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'text/plain': string
                    }
                }
            }
        }
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/resources/rst/httpschemas': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get: {
            readonly parameters: {
                readonly query?: never
                readonly header: {
                    readonly Authorization: string
                }
                readonly path?: never
                readonly cookie?: never
            }
            readonly requestBody?: never
            readonly responses: {
                /** @description Every RST related http endpoint definition */
                readonly 200: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': {
                            readonly data: {
                                readonly [key: string]: unknown
                            }
                        }
                    }
                }
                /** @description Service Unavailable (Infrastructure error) */
                readonly 503: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'text/plain': string
                    }
                }
            }
        }
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/resources/states': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    /** @description Return only deviated resources */
                    readonly deviated?: boolean & unknown
                    /** @description Number of items per page */
                    readonly itemsPerPage?: number
                    /** @description Page to return */
                    readonly page?: number
                    /** @description Limit to `ResourceID`s */
                    readonly resourceIds?: readonly string[]
                    /** @description Limit to `ServiceID`s */
                    readonly serviceIds?: readonly string[]
                }
                readonly header: {
                    readonly Authorization: string
                }
                readonly path?: never
                readonly cookie?: never
            }
            readonly requestBody?: never
            readonly responses: {
                /** @description List of resources including their state and status.
                 *     If no `ServiceID`s and no `ResourceID`s are provided, it acts as a wildcard request.
                 *     Filtering for ResourceIds takes precedence over filtering for ServiceIds. Meaning as soon as `ResourceID`s are provided, the `ServiceID`s will be ignored.
                 */
                readonly 200: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': {
                            readonly data: readonly {
                                /**
                                 * Deviated
                                 * @description Flag indicating if a deviation was detected or not
                                 */
                                readonly deviated: boolean
                                /**
                                 * Info
                                 * @description Information about the resource state
                                 */
                                readonly info?: string
                                /**
                                 * Resource
                                 * @description Object containing information about a particular resource
                                 */
                                readonly resource: {
                                    /**
                                     * ResourceID
                                     * @description The fully qualified ID of a particular Cybus Resource
                                     *     which consists of ServiceID & ResourceName seperated by a "-"
                                     */
                                    readonly id: string
                                    /**
                                     * ResourceName
                                     * @description The ID of a particular Cybus Service
                                     */
                                    readonly name: string
                                }
                                /**
                                 * Resource Runner Info
                                 * @description Information about resource runner status
                                 */
                                readonly runnerInfo?: {
                                    /**
                                     * Name
                                     * @description Resource Runner Name
                                     */
                                    readonly name: string
                                    /**
                                     * Status
                                     * @description Resource Runner Status
                                     * @enum {string}
                                     */
                                    readonly status: 'healthy' | 'unhealthy' | 'unknown'
                                }
                                /**
                                 * Resource State
                                 * @description State information of a resource
                                 */
                                readonly state: {
                                    /**
                                     * State
                                     * @description Representing an arbitrary state
                                     */
                                    readonly current: string
                                    /**
                                     * State
                                     * @description Representing an arbitrary state
                                     */
                                    readonly desired: string
                                }
                            }[]
                            readonly meta: {
                                readonly pagination: {
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly nextPage: number
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly pageNumber: number
                                    /**
                                     * @description Number of items per page
                                     * @default 50
                                     */
                                    readonly rowsPerPage: number
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly totalPages: number
                                    readonly totalRows: number
                                    readonly totalRowsInPage: number
                                }
                            }
                        }
                        readonly 'text/event-stream': {
                            /**
                             * Deviated
                             * @description Flag indicating if a deviation was detected or not
                             */
                            readonly deviated: boolean
                            /**
                             * Info
                             * @description Information about the resource state
                             */
                            readonly info?: string
                            /**
                             * Resource
                             * @description Object containing information about a particular resource
                             */
                            readonly resource: {
                                /**
                                 * ResourceID
                                 * @description The fully qualified ID of a particular Cybus Resource
                                 *     which consists of ServiceID & ResourceName seperated by a "-"
                                 */
                                readonly id: string
                                /**
                                 * ResourceName
                                 * @description The ID of a particular Cybus Service
                                 */
                                readonly name: string
                            }
                            /**
                             * Resource Runner Info
                             * @description Information about resource runner status
                             */
                            readonly runnerInfo?: {
                                /**
                                 * Name
                                 * @description Resource Runner Name
                                 */
                                readonly name: string
                                /**
                                 * Status
                                 * @description Resource Runner Status
                                 * @enum {string}
                                 */
                                readonly status: 'healthy' | 'unhealthy' | 'unknown'
                            }
                            /**
                             * Resource State
                             * @description State information of a resource
                             */
                            readonly state: {
                                /**
                                 * State
                                 * @description Representing an arbitrary state
                                 */
                                readonly current: string
                                /**
                                 * State
                                 * @description Representing an arbitrary state
                                 */
                                readonly desired: string
                            }
                        }
                    }
                }
                /** @description Service Unavailable (Infrastructure error) */
                readonly 503: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'text/plain': string
                    }
                }
            }
        }
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/resources/states/deviations': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    /** @description Number of items per page */
                    readonly itemsPerPage?: number
                    /** @description Page to return */
                    readonly page?: number
                    /** @description Limit to `ResourceID`s */
                    readonly resourceIds?: readonly string[]
                    /** @description Limit to `ServiceID`s */
                    readonly serviceIds?: readonly string[]
                }
                readonly header: {
                    readonly Authorization: string
                }
                readonly path?: never
                readonly cookie?: never
            }
            readonly requestBody?: never
            readonly responses: {
                /** @description List of resource state deviations, allowing to identify resources that have diverged from their expected states */
                readonly 200: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': {
                            readonly data: readonly {
                                /**
                                 * Deviated
                                 * @description Flag indicating if a deviation was detected or not
                                 */
                                readonly deviated: boolean
                                /**
                                 * Info
                                 * @description Information about the resource state
                                 */
                                readonly info?: string
                                /**
                                 * Resource
                                 * @description Object containing information about a particular resource
                                 */
                                readonly resource: {
                                    /**
                                     * ResourceID
                                     * @description The fully qualified ID of a particular Cybus Resource
                                     *     which consists of ServiceID & ResourceName seperated by a "-"
                                     */
                                    readonly id: string
                                    /**
                                     * ResourceName
                                     * @description The ID of a particular Cybus Service
                                     */
                                    readonly name: string
                                }
                                /**
                                 * Resource Runner Info
                                 * @description Information about resource runner status
                                 */
                                readonly runnerInfo?: {
                                    /**
                                     * Name
                                     * @description Resource Runner Name
                                     */
                                    readonly name: string
                                    /**
                                     * Status
                                     * @description Resource Runner Status
                                     * @enum {string}
                                     */
                                    readonly status: 'healthy' | 'unhealthy' | 'unknown'
                                }
                                /**
                                 * Resource State
                                 * @description State information of a resource
                                 */
                                readonly state: {
                                    /**
                                     * State
                                     * @description Representing an arbitrary state
                                     */
                                    readonly current: string
                                    /**
                                     * State
                                     * @description Representing an arbitrary state
                                     */
                                    readonly desired: string
                                }
                            }[]
                            readonly meta: {
                                readonly pagination: {
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly nextPage: number
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly pageNumber: number
                                    /**
                                     * @description Number of items per page
                                     * @default 50
                                     */
                                    readonly rowsPerPage: number
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly totalPages: number
                                    readonly totalRows: number
                                    readonly totalRowsInPage: number
                                }
                            }
                        }
                        readonly 'text/event-stream': {
                            /**
                             * Deviated
                             * @description Flag indicating if a deviation was detected or not
                             */
                            readonly deviated: boolean
                            /**
                             * Info
                             * @description Information about the resource state
                             */
                            readonly info?: string
                            /**
                             * Resource
                             * @description Object containing information about a particular resource
                             */
                            readonly resource: {
                                /**
                                 * ResourceID
                                 * @description The fully qualified ID of a particular Cybus Resource
                                 *     which consists of ServiceID & ResourceName seperated by a "-"
                                 */
                                readonly id: string
                                /**
                                 * ResourceName
                                 * @description The ID of a particular Cybus Service
                                 */
                                readonly name: string
                            }
                            /**
                             * Resource Runner Info
                             * @description Information about resource runner status
                             */
                            readonly runnerInfo?: {
                                /**
                                 * Name
                                 * @description Resource Runner Name
                                 */
                                readonly name: string
                                /**
                                 * Status
                                 * @description Resource Runner Status
                                 * @enum {string}
                                 */
                                readonly status: 'healthy' | 'unhealthy' | 'unknown'
                            }
                            /**
                             * Resource State
                             * @description State information of a resource
                             */
                            readonly state: {
                                /**
                                 * State
                                 * @description Representing an arbitrary state
                                 */
                                readonly current: string
                                /**
                                 * State
                                 * @description Representing an arbitrary state
                                 */
                                readonly desired: string
                            }
                        }
                    }
                }
                /** @description Service Unavailable (Infrastructure error) */
                readonly 503: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'text/plain': string
                    }
                }
            }
        }
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/resources/states/deviations/count': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    /** @description Limit to `ServiceID`s */
                    readonly ids?: readonly string[]
                    /** @description Number of items per page */
                    readonly itemsPerPage?: number
                    /** @description Page to return */
                    readonly page?: number
                }
                readonly header: {
                    readonly Authorization: string
                }
                readonly path?: never
                readonly cookie?: never
            }
            readonly requestBody?: never
            readonly responses: {
                /** @description Number of resources currently in a deviated state.
                 *     If no filter is applied the number represents the system wide deviations.
                 */
                readonly 200: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': {
                            readonly data:
                                | readonly {
                                    /**
                                     * Deviations Count
                                     * @description The current number of deviations
                                     */
                                    readonly count: number
                                    /**
                                     * ServiceID
                                     * @description The ID of a particular Cybus Service
                                     */
                                    readonly serviceId: string
                                }[]
                                | number
                            readonly meta: {
                                readonly pagination: {
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly nextPage: number
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly pageNumber: number
                                    /**
                                     * @description Number of items per page
                                     * @default 50
                                     */
                                    readonly rowsPerPage: number
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly totalPages: number
                                    readonly totalRows: number
                                    readonly totalRowsInPage: number
                                }
                            }
                        }
                        readonly 'text/event-stream': {
                            /**
                             * Deviations Count
                             * @description The current number of deviations
                             */
                            readonly count: number
                            /**
                             * ServiceID
                             * @description The ID of a particular Cybus Service
                             */
                            readonly serviceId: string
                        } | number
                    }
                }
                /** @description Service Unavailable (Infrastructure error) */
                readonly 503: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'text/plain': string
                    }
                }
            }
        }
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
    readonly '/api/v2/resources/states/deviations/services': {
        readonly parameters: {
            readonly query?: never
            readonly header?: never
            readonly path?: never
            readonly cookie?: never
        }
        readonly get: {
            readonly parameters: {
                readonly query?: {
                    /** @description Number of items per page */
                    readonly itemsPerPage?: number
                    /** @description Ascending or descending order */
                    readonly order?: 'ASC' | 'DESC'
                    /** @description Order response by field */
                    readonly orderBy?: 'serviceId'
                    /** @description Page to return */
                    readonly page?: number
                    /** @description The value used to retrieve services by matching service IDs */
                    readonly searchText?: string
                }
                readonly header: {
                    readonly Authorization: string
                }
                readonly path?: never
                readonly cookie?: never
            }
            readonly requestBody?: never
            readonly responses: {
                /** @description Returns a list of deviated ServiceIds along with their number of deviated resources
                 */
                readonly 200: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': {
                            readonly data: readonly {
                                /**
                                 * Deviations Count
                                 * @description The current number of deviations
                                 */
                                readonly count: number
                                /**
                                 * ServiceID
                                 * @description The ID of a particular Cybus Service
                                 */
                                readonly serviceId: string
                            }[]
                            readonly jsonapi: {
                                /** @example 1.1.1 */
                                readonly version: string
                            }
                            readonly meta: {
                                readonly pagination: {
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly nextPage: number
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly pageNumber: number
                                    /**
                                     * @description Number of items per page
                                     * @default 50
                                     */
                                    readonly rowsPerPage: number
                                    /**
                                     * @description A page number
                                     * @default 1
                                     */
                                    readonly totalPages: number
                                    readonly totalRows: number
                                    readonly totalRowsInPage: number
                                }
                            }
                        }
                        readonly 'text/event-stream': {
                            /**
                             * Deviations Count
                             * @description The current number of deviations
                             */
                            readonly deviatedServices: number
                            /** Service Deviation State */
                            readonly service?: {
                                /**
                                 * Deviated
                                 * @description Flag indicating if a deviation was detected or not
                                 */
                                readonly deviated: boolean
                                /**
                                 * ServiceID
                                 * @description The ID of a particular Cybus Service
                                 */
                                readonly serviceId: string
                            }
                        }
                    }
                }
                /** @description Bad Request */
                readonly 400: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': {
                            readonly errors: readonly {
                                /** @example invalid parameter for orderBy */
                                readonly detail: string
                                /** @example 400 */
                                readonly status: string
                                /** @example Invalid parameters provided. */
                                readonly title: string
                            }[]
                            readonly jsonapi: {
                                /** @example 1.1.1 */
                                readonly version: string
                            }
                        }
                    }
                }
                /** @description Internal Server Error */
                readonly 500: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'application/json': {
                            readonly errors: readonly {
                                /** @example invalid parameter for orderBy */
                                readonly detail: string
                                /** @example 400 */
                                readonly status: string
                                /** @example Invalid parameters provided. */
                                readonly title: string
                            }[]
                            readonly jsonapi: {
                                /** @example 1.1.1 */
                                readonly version: string
                            }
                        }
                    }
                }
                /** @description Service Unavailable (Infrastructure error) */
                readonly 503: {
                    headers: {
                        readonly [name: string]: unknown
                    }
                    content: {
                        readonly 'text/plain': string
                    }
                }
            }
        }
        readonly put?: never
        readonly post?: never
        readonly delete?: never
        readonly options?: never
        readonly head?: never
        readonly patch?: never
        readonly trace?: never
    }
}
export type components = {
    schemas: {
        readonly httpSchema: {
            readonly [key: string]: unknown
        }
        /**
         * @description Number of items per page
         * @default 50
         */
        readonly itemsPerPage: number
        /**
         * @description Number of items per page
         * @default 50
         */
        readonly itemsPerPageLarge: number
        readonly JSONAPI: {
            /** @example 1.1.1 */
            readonly version: string
        }
        readonly JSONAPIError: {
            readonly errors: readonly {
                /** @example invalid parameter for orderBy */
                readonly detail: string
                /** @example 400 */
                readonly status: string
                /** @example Invalid parameters provided. */
                readonly title: string
            }[]
            readonly jsonapi: {
                /** @example 1.1.1 */
                readonly version: string
            }
        }
        readonly JsonApiresourceDeviationsCountsListEnvelope: {
            readonly data: readonly {
                /**
                 * Deviations Count
                 * @description The current number of deviations
                 */
                readonly count: number
                /**
                 * ServiceID
                 * @description The ID of a particular Cybus Service
                 */
                readonly serviceId: string
            }[]
            readonly jsonapi: {
                /** @example 1.1.1 */
                readonly version: string
            }
            readonly meta: {
                readonly pagination: {
                    /**
                     * @description A page number
                     * @default 1
                     */
                    readonly nextPage: number
                    /**
                     * @description A page number
                     * @default 1
                     */
                    readonly pageNumber: number
                    /**
                     * @description Number of items per page
                     * @default 50
                     */
                    readonly rowsPerPage: number
                    /**
                     * @description A page number
                     * @default 1
                     */
                    readonly totalPages: number
                    readonly totalRows: number
                    readonly totalRowsInPage: number
                }
            }
        }
        /** @example 1.1.1 */
        readonly JSONAPIVersion: string
        /**
         * @description A page number
         * @default 1
         */
        readonly pageNumber: number
        readonly pagination: {
            /**
             * @description A page number
             * @default 1
             */
            readonly nextPage: number
            /**
             * @description A page number
             * @default 1
             */
            readonly pageNumber: number
            /**
             * @description Number of items per page
             * @default 50
             */
            readonly rowsPerPage: number
            /**
             * @description A page number
             * @default 1
             */
            readonly totalPages: number
            readonly totalRows: number
            readonly totalRowsInPage: number
        }
        readonly paginationLarge: {
            /**
             * @description A page number
             * @default 1
             */
            readonly nextPage: number
            /**
             * @description A page number
             * @default 1
             */
            readonly pageNumber: number
            /**
             * @description Number of items per page
             * @default 50
             */
            readonly rowsPerPage: number
            /**
             * @description A page number
             * @default 1
             */
            readonly totalPages: number
            readonly totalRows: number
            readonly totalRowsInPage: number
        }
        readonly resourceDeviationsCountsList: readonly {
            /**
             * Deviations Count
             * @description The current number of deviations
             */
            readonly count: number
            /**
             * ServiceID
             * @description The ID of a particular Cybus Service
             */
            readonly serviceId: string
        }[]
        readonly resourceRunners: readonly {
            /**
             * Resource runner health
             * @description Represents if resource runners are or not healthy
             */
            readonly healthy: boolean
            readonly hostname: string
            readonly last: number
            /**
             * Resource runner missed heartbeats
             * @description Represents the count of missed heartbeats
             */
            readonly misses: number
            /**
             * Name
             * @description Resource Runner Name
             */
            readonly name: string
            /**
             * Resource runner remaining missed heartbeats
             * @description Represents the number of allowed heartbeats misses for the resource runner
             *     until it becomes unhealthy
             */
            readonly remainingMissedHeartbeats: number
            readonly version: string
        }[]
        readonly resourceStateList: readonly {
            /**
             * Deviated
             * @description Flag indicating if a deviation was detected or not
             */
            readonly deviated: boolean
            /**
             * Info
             * @description Information about the resource state
             */
            readonly info?: string
            /**
             * Resource
             * @description Object containing information about a particular resource
             */
            readonly resource: {
                /**
                 * ResourceID
                 * @description The fully qualified ID of a particular Cybus Resource
                 *     which consists of ServiceID & ResourceName seperated by a "-"
                 */
                readonly id: string
                /**
                 * ResourceName
                 * @description The ID of a particular Cybus Service
                 */
                readonly name: string
            }
            /**
             * Resource Runner Info
             * @description Information about resource runner status
             */
            readonly runnerInfo?: {
                /**
                 * Name
                 * @description Resource Runner Name
                 */
                readonly name: string
                /**
                 * Status
                 * @description Resource Runner Status
                 * @enum {string}
                 */
                readonly status: 'healthy' | 'unhealthy' | 'unknown'
            }
            /**
             * Resource State
             * @description State information of a resource
             */
            readonly state: {
                /**
                 * State
                 * @description Representing an arbitrary state
                 */
                readonly current: string
                /**
                 * State
                 * @description Representing an arbitrary state
                 */
                readonly desired: string
            }
        }[]
    }
    responses: {
        /** @description Service Unavailable (Infrastructure error) */
        readonly ServiceUnavailable: {
            headers: {
                readonly [name: string]: unknown
            }
            content: {
                readonly 'text/plain': string
            }
        }
    }
    parameters: never
    requestBodies: never
    headers: never
    pathItems: never
}

/** An auto-generated constant containing all paths */
export const pathsValue = [
    '/api/v2/resource-runners' as const,
    '/api/v2/resources/rst/httpschemas' as const,
    '/api/v2/resources/states' as const,
    '/api/v2/resources/states/deviations' as const,
    '/api/v2/resources/states/deviations/count' as const,
    '/api/v2/resources/states/deviations/services' as const,
]
